<template lang="pug">
  .sidebar-container(v-on-clickaway='closeSideBar')
    button.burger-menu(type='button' @click='showElement({ element: "sidebarMenu" })')
      img.burger-icon(src='../assets/ic_hamburguer_blue.svg' alt='Menu')
    .sidebar-menu.column.space-between(:class='{ show: showSidebar, "student-sidebar-menu": inStudentPublicResource }')
      div(v-if='!inStudentPublicResource')
        .actions-container.column.center
          .row.close-container.space-between.width-100
            simple-svg.white-icon(:filepath='kimpleLogo' :height='"29px"')
            button.close-button.m4-bottom-10(type='button' @click='hideElement({ element: "sidebarMenu"})')
              simple-svg.white-icon(:filepath='closeIcon' :width='"20px"' :height='"20px"')
          .column.center.width-100(v-if='!isLogged')
            router-link.first-link.row.middle.text-big.white.sidebar-button.width-100(
              :to='{ name: routes.home }'
              exact-active-class='active-landing'
            ) {{ $t('navbar.home') }}
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{ name: routes.content }' exact-active-class='active-landing')
              | {{ $t('navbar.content') }}
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{ name: routes.howItWorks }' exact-active-class='active-landing')
              | {{ $t('navbar.howItWorks') }}
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{ name: routes.impact }' exact-active-class='active-landing')
              | {{ $t('navbar.impact') }}
            button.sidebar-button.width-100.row.middle.space-between(
              type='button'
              @click='changeLaguange(language.lang)'
              v-for='language in languagesAvailable'
              :key='language.lang'
            )
              .row.middle
                img.locale-icon.m-right-1(:src='language.white_icon' alt='languageSelected.lang')
                span.white.text-big {{ language.label }}
              img.check-icon(:src='languageSelected.lang === language.lang ? circleCheck : circle' alt='selection icon')
            // TODO: Add v-if the same code that is in the created function from Navbar
            router-link.primary-button.login-button.white-border.m4-top-12(type='button' :to='{name: routes.login}')
              | {{ $t('navbar.login') }}
          .column.center.width-100(v-else)
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{name: routes.feed}' exact-active-class='active-landing')
              | {{ $t('navbar.explore') }}
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{name: routes.folderList}' exact-active-class='active-landing')
              | {{ $t('navbar.myFolders') }}
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{name: routes.educationalPrograms}' exact-active-class='active-landing')
              | {{ $t('navbar.programs') }}
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{name: routes.krea}' exact-active-class='active-landing')
              | {{ $t('navbar.krea') }}
            router-link.row.middle.text-big.white.sidebar-button.width-100(:to='{name: routes.stats}' exact-active-class='active-landing')
              | {{ $t('navbar.stats') }}
            button.sidebar-button.width-100.row.middle.space-between(
              type='button'
              @click='changeLaguange(language.lang)'
              v-for='language in languagesAvailable'
              :key='language.lang'
            )
              .row.middle
                img.locale-icon.m-right-1(:src='language.white_icon' alt='languageSelected.lang')
                span.white.text-big {{ language.label }}
              img.check-icon(:src='languageSelected.lang === language.lang ? circleCheck : circle' alt='selection icon')
            button.primary-button.login-button.white-border.m4-top-12(type='button' @click='logout')
              | {{ $t('navbar.logout') }}
      .column(v-else)
        button.student-close-button.m4-top-10.m4-bottom-5.m4-left-4(type='button' @click='hideElement({ element: "sidebarMenu"})')
          simple-svg.black-icon(:filepath='closeIcon' :width='"25px"' :height='"25px"')
        sidebar-index(
          v-if='!isEmptyObject(resource)'
          :author='resource.author'
          :resourceTitle='resource.title'
          :resourceWebinar='false'
          :classes='inStudentPublicResource ? resource.classPlans.length : resource.studentMaterial.classPlans.length'
          :category='resource.category.name'
          :isStudentView='inStudentPublicResource'
        )
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'

import SidebarIndex from './Resource/SidebarIndex'

import { routes } from '../router'
import { supportedLanguages } from '../constants/languages'
import { isEmptyObject } from '../utils/object'
import { logoutUser } from '@/services/UserService'

import closeIcon from '@/assets/ic_cross.svg'
import kimpleLogo from '@/assets/ic_iso.svg'
import circle from '@/assets/ic_circle.svg'
import circleCheck from '@/assets/ic_circle_check.svg'

export default {
  data() {
    return {
      closeIcon,
      routes,
      kimpleLogo,
      circle,
      circleCheck,
      isEmptyObject,
      languagesAvailable: supportedLanguages
    }
  },
  computed: {
    ...mapState({
      showSidebar: state => state.behavior.sidebarMenu.show,
      resource: state => state.resource.resource,
      isLogged: state => state.userInfo.userLoggedIn
    }),
    inStudentPublicResource() {
      return this.$route.name === routes.studentPublicResource
    },
    languageSelected() {
      return supportedLanguages.find(language => language.lang === this.$i18n.locale)
    }
  },
  watch: {
    '$route'() {
      this.hideElement({ element: 'sidebarMenu' })
    }
  },
  methods: {
    ...mapActions([ 'showElement', 'hideElement', 'changeLocale' ]),
    showModal(modal) {
      this.hideElement({ element: 'sidebarMenu' })
      this.showElement(modal)
    },
    closeSideBar() {
      if (this.showSidebar) {
        this.hideElement({ element: 'sidebarMenu' })
      }
    },
    changeLaguange(locale) {
      this.$i18n.locale = locale
      this.changeLocale(locale)
      this.hideElement({ element: 'sidebarMenu' })
    },
    logout() {
      logoutUser()
      this.$store.dispatch('logout')
      this.hideElement({ element: 'userMenu' })
      this.$router.push({ name: routes.home })
    }
  },
  components: { SidebarIndex },
  mixins: [ clickaway ]
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';
@import '../scss/variables/sizes';
@import '../scss/variables/z-indexes';

.sidebar-container {
  display: none;
}

.burger-menu {
  right: 15px;
  position: absolute;
  top: 20px;
}

.burger-icon {
  width: 24px;
}

.sidebar-menu {
  background-color: $blue;
  height: 100vh;
  left: -100%;
  padding-bottom: 50px;
  position: fixed;
  top: 0;
  transition: all 0.5s ease;
  width: 100vw;
  z-index: $sidebar-layer;

  &.show {
    transform: translateX(100%);
  }
}

.student-sidebar-menu {
  background-color: $white;
  border: 1px solid $light-gray;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  left: -70vw;
  width: 70vw;
}

.actions-container {
  height: 330px;
}

.student-close-button {
  width: 25px;
}

.bottom-section {
  align-items: center;
  background-position-y: bottom;
  background-size: 100%;
  border-bottom: 1px solid $white;
  border-top: 1px solid $white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  & > :first-child {
    border-bottom: 1px solid $white;
  }
}

.logo {
  width: 100px;
}

.close-button {
  margin-left: -10px;
}

.starting-point {
  color: $dark-gray;
}

.modal-action {
  height: 56px;
  padding-left: 24px;
  text-align: left;
  width: 100%;
}

.login-button {
  --font-size: 18px;
  --line-height: 22px;
  box-sizing: content-box;
}

.sidebar-button {
  border-bottom: 1px solid $middle-blue;
  min-height: 56px;
  padding: 0 24px;

  &.active-landing {
    background-color: $middle-blue;
  }

  &.first-link {
    border-top: 1px solid $middle-blue;
  }
}

.close-container {
  min-height: 88px;
  padding: 24px 24px 0;
}

.locale-icon {
  height: 20px;
  width: 28px;
}

@media screen and (max-width: $mobile-break) {
  .sidebar-container {
    display: block;
  }
}
</style>
